import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=7db66d23&scoped=true&"
import script from "./MessageList.vue?vue&type=script&lang=ts&"
export * from "./MessageList.vue?vue&type=script&lang=ts&"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=7db66d23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db66d23",
  null
  
)

export default component.exports